import React, { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("about");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuItemClick = (sectionId) => {
    setActiveSection(sectionId);
    setIsOpen(false);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems = [
    { id: "about", label: "About" },
    { id: "skills", label: "Skills" },
    { id: "work", label: "Projects" },
    { id: "education", label: "Education" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 px-[6vw] md:px-[8vw] lg:px-[15vw] ${
        isScrolled
          ? "bg-[#050414]/80 backdrop-blur-xl border-b border-purple-500/10 shadow-[0_4px_30px_rgba(0,0,0,0.5)] py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div 
          onClick={() => handleMenuItemClick("about")}
          className="text-xl font-bold tracking-wider cursor-pointer group flex items-center space-x-1"
        >
          <span className="text-[#8245ec] group-hover:-translate-x-1 transition-transform">&lt;</span>
          <span className="text-white font-mono">Yash</span>
          <span className="text-[#8245ec]">.</span>
          <span className="text-white font-mono">Soni</span>
          <span className="text-[#8245ec] group-hover:translate-x-1 transition-transform">&gt;</span>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-8 bg-white/[0.03] border border-white/10 px-6 py-2 rounded-full backdrop-blur-md">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => handleMenuItemClick(item.id)}
                className={`text-sm font-medium transition-colors hover:text-[#8245ec] relative py-1 ${
                  activeSection === item.id ? "text-[#8245ec]" : "text-gray-300"
                }`}
              >
                {item.label}
                {activeSection === item.id && (
                  <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#8245ec] to-purple-400 rounded-full animate-pulse" />
                )}
              </button>
            </li>
          ))}
        </ul>

        {/* Social Icons */}
        <div className="hidden lg:flex items-center space-x-4">
          <a
            href="https://github.com/yashhssoni"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white/[0.05] border border-white/10 flex items-center justify-center text-gray-300 hover:text-white hover:border-[#8245ec] hover:bg-[#8245ec]/20 transition-all duration-300"
          >
            <FaGithub size={18} />
          </a>
          <a
            href="https://www.linkedin.com/in/yashhsoni/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white/[0.05] border border-white/10 flex items-center justify-center text-gray-300 hover:text-white hover:border-[#8245ec] hover:bg-[#8245ec]/20 transition-all duration-300"
          >
            <FaLinkedin size={18} />
          </a>
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-10 h-10 rounded-full bg-white/[0.05] border border-white/10 flex items-center justify-center text-[#8245ec]"
          >
            {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-[#050414]/95 backdrop-blur-2xl border-b border-purple-500/20 shadow-2xl py-6 md:hidden">
          <ul className="flex flex-col items-center space-y-4">
            {menuItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => handleMenuItemClick(item.id)}
                  className={`text-lg font-medium transition-colors ${
                    activeSection === item.id ? "text-[#8245ec]" : "text-gray-300"
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
            <div className="flex space-x-6 pt-4 border-t border-white/10 w-3/4 justify-center">
              <a href="https://github.com/yashhssoni" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#8245ec]">
                <FaGithub size={22} />
              </a>
              <a href="https://www.linkedin.com/in/yashhsoni/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#8245ec]">
                <FaLinkedin size={22} />
              </a>
            </div>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;